import React, { memo } from 'react';

import ContentLoader from 'react-content-loader';

function TitlePlaceholder() {
    return (
        <ContentLoader
            width="100%"
            height="135"
            speed={2}
            backgroundColor="#e1e4e8"
            foregroundColor="#f8f8f8"
        >
            <rect
                x="0"
                y="0"
                width="350"
                height="30"
            />
            <rect
                x="0"
                y="50"
                width="300"
                height="30"
            />
            <rect
                x="0"
                y="90"
                width="170"
                height="20"
            />
        </ContentLoader>
    );
}

function ImagePlaceholder({ ...rest }) {
    return (
        <ContentLoader
            width="100%"
            height="100%"
            {...rest}
            speed={2}
            backgroundColor="#e1e4e8"
            foregroundColor="#f8f8f8"
        >
            <rect
                x="0"
                y="0"
                width="100%"
                height="100%"
            />
        </ContentLoader>
    );
}

const BuildAndPriceMainImagePlaceholder = memo(() => (
    <>
        <TitlePlaceholder />
        <ImagePlaceholder style={{ aspectRatio: '313 / 146' }} />
    </>
));

export default BuildAndPriceMainImagePlaceholder;
